// dependencies imports ⇒
import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

// assets and scss imports ⇒
import "./abhaClinicRecords.scss";
import addIcon from "../../../../assets/add-icon-bold.svg";
import PrimaryButton from "../../../common/Buttons/PrimaryButton";
import SecondaryButton from "../../../common/Buttons/SecondaryButton";
import moment from "moment";
import { PROD } from "../../../common/config";

// project file imports(UI components) ⇒

// const file imports(helper methods, etc) ⇒

const AbhaClinicRecords = (props) => {
  // const declarations ⇒
  const {
    patientAccountList,
    handleShowConfirmationModal,
    handleAddNewPatient,
    handleBookAppointment,
    loader,
  } = props;

  // let or var declarations ⇒

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒
  const getAbhaAddress = (abhaAddress) => {
    return `${
      abhaAddress + (process.env.REACT_APP_ENV !== PROD ? "@sbx" : "@abdm")
    }`;
  };

  // Actions ⇒

  // create UI ⇒
  const abhaClinicAddPatientUI = () => {
    return (
      <div className="acr-add-patient-container" onClick={handleAddNewPatient}>
        <div className="arc-add-icon-container">
          <img src={addIcon} alt="" className="arc-add-icon" />
        </div>
        <div className="arc-add-patient-content">
          Add new patient with the above ABHA details
        </div>
      </div>
    );
  };

  const abhaClinicPatientList = () => {
    return (
      <div className="acr-patient-list-container">
        {patientAccountList?.map((patient, index) => (
          <div className="acr-patient-card-container" key={index}>
            <div className="acr-patient-name">{patient?.patient_name}</div>
            <div className="acr-patient-details-container">
              <div>
                {abhaContentTextField("Gender", patient?.patient_gender)}
              </div>
              {patient?.patient_dob && (
                <div>
                  {abhaContentTextField(
                    "DOB",
                    moment(patient?.patient_dob).format("MMM DD, YYYY")
                  )}
                </div>
              )}
            </div>
            {patient?.preferred_abha_address && (
              <div className="acr-abha-address-container">
                {abhaContentTextField(
                  "ABHA ADDRESS",
                  patient?.preferred_abha_address
                    ? getAbhaAddress(patient?.preferred_abha_address)
                    : ""
                )}
              </div>
            )}
            <div className="acr-card-button-container">
              <PrimaryButton
                title="Book Appointment"
                handleButtonClick={() => {
                  handleBookAppointment(patient);
                }}
              />

              {patient?.existing_appointments && (
                <SecondaryButton
                  title="Link to Existing Appointments"
                  handleButtonClick={() => {
                    handleShowConfirmationModal(patient);
                  }}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const abhaContentTextField = (label, value) => {
    return (
      <div className="acr-text-content">
        <div className="acr-text-content-label">{label}</div>
        <div className="acr-text-content-value">{value}</div>
      </div>
    );
  };

  const abhaClinicRecordsListUI = () => {
    return (
      <>
        <div className="arc-heading">
          Clinic Records {`(${patientAccountList?.length})`}
        </div>
        <div className="acr-container">
          {abhaClinicAddPatientUI()}
          {loader ? (
            <div className="acr-loader-container">
              <CircularProgress style={{ color: "#15BAE0" }} />
            </div>
          ) : (
            abhaClinicPatientList()
          )}
        </div>
      </>
    );
  };

  return <div className="abha-clinic-records">{abhaClinicRecordsListUI()}</div>;
};

// export ⇒

export default AbhaClinicRecords;
